module.exports = __webpack_public_path__ + "8706fff5c46668af9851a6fb9b77bc06.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/bella-sheer-triblend-racerback-blue.png
// module id = 828
// module chunks = 0